"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mcGilla = exports.boundaries = exports.nested = exports.peers = exports.overlaps = exports.basic = exports.multiples = void 0;
var text = "CT ANGIO ABDOMEN/PELVIS WITH AND WITHOUT CONTRAST ";
var seg0 = {
    text: text,
    start: 0,
    end: 50
};
var seg1 = {
    text: text,
    start: 50,
    end: 100
};
var seg2 = {
    text: text,
    start: 100,
    end: 150
};
var span0 = {
    span: {
        start: 3,
        end: 23,
        document_id: 234325,
        content: "some content here D",
        uuid: "blah"
    },
    codeType: "icd",
    code: {
        confidence: 0.9900000000000001,
        diagnosis_code: "V66.6",
        uuid: "blah211",
        evidence: []
    },
    active: false
};
var span1 = {
    span: {
        start: 53,
        end: 74,
        document_id: 234325,
        content: "some content here C",
        uuid: "blah2"
    },
    codeType: "icd",
    code: {
        confidence: 0.9900000000000001,
        diagnosis_code: "V66.6",
        uuid: "blah311",
        evidence: []
    },
    active: true
};
var span2 = {
    span: {
        start: 83,
        end: 90,
        document_id: 234325,
        content: "some content here B",
        uuid: "blah3"
    },
    codeType: "cpt",
    code: {
        confidence: 0.9900000000000001,
        diagnosis_code: "V66.6",
        uuid: "blah411",
        evidence: []
    },
    active: true
};
var span3 = {
    span: {
        start: 133,
        end: 140,
        document_id: 234325,
        content: "some content here A",
        uuid: "blah4"
    },
    codeType: "cpt",
    code: {
        confidence: 0.9900000000000001,
        diagnosis_code: "V66.6",
        uuid: "blah511",
        evidence: []
    },
    active: false
};
exports.multiples = {
    segments: [seg0, seg1, seg2],
    spans: [span0, span1, span2, span3]
};
exports.basic = { segments: [seg0], spans: [span0] };
// overlaps
exports.overlaps = (function () {
    var spanA = __assign(__assign({}, span0), { span: __assign(__assign({}, span0.span), { end: span0.span.start + 13 }) });
    var spanB = __assign(__assign({}, span0), { span: __assign(__assign({}, span0.span), { content: "some content here", start: 9, end: 23 }) });
    var spanC = {
        span: {
            start: 17,
            end: 28,
            document_id: 234325,
            content: "some content here 2",
            uuid: "blah5"
        },
        codeType: "cpt",
        code: {
            confidence: 0.9900000000000001,
            diagnosis_code: "72250",
            uuid: "blah222",
            evidence: []
        },
        active: true
    };
    return { segments: [seg0], spans: [spanA, spanB, spanC] };
})();
// peers
// ex: cpt and icd pointing to the same segment
exports.peers = (function () {
    var span2 = __assign(__assign({}, span0), { codeType: "cpt" });
    return { spans: [span0, span2], segments: [seg0] };
})();
// nested
// spans within spans, does not cross
exports.nested = (function () {
    var span0 = {
        span: {
            start: 53,
            end: 73,
            content: "some content here E",
            document_id: 234325,
            uuid: "blah"
        },
        codeType: "icd",
        code: {
            confidence: 0.9900000000000001,
            diagnosis_code: "V66.6",
            uuid: "blah211",
            evidence: []
        },
        active: false
    };
    var span01 = {
        span: {
            start: 59,
            end: 73,
            content: "some content here F",
            document_id: 234325,
            uuid: "blah6"
        },
        codeType: "cpt",
        code: {
            confidence: 0.9900000000000001,
            diagnosis_code: "V66.6",
            uuid: "blah711",
            evidence: []
        },
        active: false
    };
    var span02 = {
        span: {
            start: 56,
            end: 64,
            content: "some content here G",
            document_id: 234325,
            uuid: "blah7"
        },
        codeType: "icd",
        code: {
            confidence: 0.9900000000000001,
            diagnosis_code: "V66.6",
            uuid: "blah811",
            evidence: []
        },
        active: true
    };
    var span1 = {
        span: {
            start: 67,
            end: 73,
            content: "some content here H",
            document_id: 234325,
            uuid: "blah8"
        },
        codeType: "icd",
        code: {
            confidence: 0.9900000000000001,
            diagnosis_code: "V66.6",
            uuid: "blah911",
            evidence: []
        },
        active: true
    };
    return { spans: [span0, span02, span01, span1], segments: [seg1] };
})();
// boundaries
// spans within spans, crossing boundaries
exports.boundaries = {
    segments: [
        {
            text: text,
            content: "some content here H",
            start: 0,
            end: 50
        },
        {
            text: text,
            content: "some content here I",
            start: 50,
            end: 100
        },
        {
            text: text,
            content: "some content here J",
            start: 100,
            end: 150
        }
    ],
    spans: [
        {
            span: {
                start: 25,
                end: 30,
                content: "some content here K",
                document_id: 234325,
                uuid: "blah9"
            },
            codeType: "icd",
            code: {
                confidence: 0.9900000000000001,
                diagnosis_code: "V66.6",
                uuid: "blah777",
                evidence: []
            },
            active: false
        },
        {
            span: {
                start: 83,
                end: 90,
                content: "some content here L",
                document_id: 234325,
                uuid: "blah10"
            },
            codeType: "cpt",
            code: {
                confidence: 0.9900000000000001,
                diagnosis_code: "V66.6",
                uuid: "blah888",
                evidence: []
            },
            active: true
        }
    ]
};
// mcgilla - all of the problem conditions
exports.mcGilla = (function () {
    var segments = [
        {
            text: text,
            content: "some content here M",
            start: 0,
            end: 50
        },
        {
            text: text,
            content: "some content here N",
            start: 50,
            end: 100
        },
        {
            text: text,
            content: "some content here O",
            start: 100,
            end: 150
        }
    ];
    var spans = [
        {
            span: {
                start: 20,
                end: 120,
                content: "some content here P",
                document_id: 234325,
                uuid: "blah11"
            },
            codeType: "icd",
            code: {
                uuid: "blah111",
                confidence: 0.9900000000000001,
                diagnosis_code: "V66.6",
                evidence: []
            },
            active: false
        },
        {
            span: {
                start: 41,
                end: 52,
                content: "some content here Q",
                document_id: 234325,
                uuid: "blah12"
            },
            codeType: "cpt",
            code: {
                uuid: "blah112",
                confidence: 0.9900000000000001,
                diagnosis_code: "V66.6",
                evidence: []
            },
            active: false
        },
        {
            span: {
                start: 48,
                end: 51,
                content: "some content here R",
                document_id: 234325,
                uuid: "blah12"
            },
            codeType: "cpt",
            code: {
                uuid: "blah112",
                confidence: 0.9900000000000001,
                diagnosis_code: "V66.6",
                evidence: []
            },
            active: false
        },
        {
            span: {
                start: 83,
                end: 90,
                content: "some content here S",
                document_id: 234325,
                uuid: "blah13"
            },
            codeType: "cpt",
            code: {
                uuid: "blah113",
                confidence: 0.9900000000000001,
                diagnosis_code: "V66.6",
                evidence: []
            },
            active: true
        }
    ];
    return { spans: spans, segments: segments };
})();
//# sourceMappingURL=spans.js.map